import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useNavigate, useParams } from "react-router-dom";
import expenseService from "../../services/ExpenseService";
import expenseCategoryService from "../../services/ExpenseCategoryService";
import FinancialAccountService from "../../services/FinancialAccountService";

export default function ExpenseEditPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    const { id } = useParams();
    const [expense, setExpense] = useState({
        id: 0,
        description: "",
        amount: 0,
        expenseDate: new Date(),
        isRecurring: false,
        expenseCategoryId: 0,
        expenseCategoryName: "",
        financialAccountId: null
    });

    const [categories, setCategories] = useState([]);
    const [financialAccounts, setFinancialAccounts] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadData();
    }, [id]);

    const loadData = async () => {
        try {
            const [catRes, expRes, accRes] = await Promise.all([
                expenseCategoryService.getAll(),
                expenseService.getById(id),
                FinancialAccountService.getAll()
            ]);

            setCategories(catRes.data || catRes);
            if (accRes.success) setFinancialAccounts(accRes.data || []);

            const result = expRes.data || expRes;
            if (result.success) {
                setExpense({
                    ...result.data,
                    expenseDate: new Date(result.data.expenseDate)
                });
            } else {
                toast.current.show({ severity: "error", summary: "Hata", detail: "Gider yüklenemedi!" });
            }
        } catch (error) {
            console.error("Data load error", error);
        }
    };

    const searchCategories = (event) => {
        const query = event.query.toLowerCase();
        let _filtered = categories.filter(c => c.name.toLowerCase().includes(query));

        if (_filtered.length === 0 && query.length > 0) {
            _filtered = [{ id: 0, name: event.query, isNew: true }];
        }

        setFilteredCategories(_filtered);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!expense.expenseCategoryName) {
            toast.current.show({ severity: "warn", summary: "Uyarı", detail: "Gider başlığı seçiniz!" });
            return;
        }

        if (expense.amount <= 0) {
            toast.current.show({ severity: "warn", summary: "Uyarı", detail: "Tutar 0'dan büyük olmalıdır!" });
            return;
        }

        if (!expense.financialAccountId) {
            toast.current.show({ severity: "warn", summary: "Uyarı", detail: "Ödemenin yapılacağı hesabı seçiniz!" });
            return;
        }

        try {
            setLoading(true);
            const res = await expenseService.update(expense);
            const result = res.data || res;
            if (result.success) {
                toast.current.show({ severity: "success", summary: "Başarılı", detail: "Gider güncellendi." });
                setTimeout(() => navigate("/expenses"), 1500);
            } else {
                toast.current.show({ severity: "error", summary: "Hata", detail: result.message || "Hata oluştu!" });
            }
        } catch (error) {
            toast.current.show({ severity: "error", summary: "Hata", detail: "İşlem başarısız!" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-2 md:p-6 bg-slate-50 min-h-screen">
            <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
            <div className="max-w-3xl mx-auto">
                <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-200/60 border border-slate-100 overflow-hidden">
                    <div className="bg-indigo-600 p-8 md:p-10 text-white relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -mr-20 -mt-20 blur-3xl"></div>
                        <div className="relative z-10 flex items-center gap-6">
                            <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-[1.25rem] flex items-center justify-center shadow-inner">
                                <i className="pi pi-pencil text-3xl"></i>
                            </div>
                            <div>
                                <h1 className="text-3xl font-black uppercase tracking-tight">Gider Kaydı Düzenle</h1>
                                <p className="text-indigo-100 text-sm font-medium mt-1">Gider kaydını güncelleyin.</p>
                            </div>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="p-8 md:p-10 space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="space-y-2">
                                <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">GİDER BAŞLIĞI</label>
                                <AutoComplete
                                    value={expense.expenseCategoryName}
                                    suggestions={filteredCategories}
                                    completeMethod={searchCategories}
                                    field="name"
                                    onChange={(e) => {
                                        const val = e.value;
                                        if (typeof val === 'string') {
                                            setExpense({ ...expense, expenseCategoryName: val, expenseCategoryId: 0 });
                                        } else {
                                            setExpense({ ...expense, expenseCategoryName: val.name, expenseCategoryId: val.id });
                                        }
                                    }}
                                    placeholder="Başlık seçin veya yeni yazın..."
                                    className="w-full"
                                    inputClassName="!w-full !py-3.5 !px-5 !rounded-2xl border-slate-200 focus:border-indigo-500 transition-all font-bold text-slate-700"
                                />
                            </div>

                            <div className="space-y-2">
                                <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">GİDER TARİHİ</label>
                                <Calendar
                                    value={expense.expenseDate}
                                    onChange={(e) => setExpense({ ...expense, expenseDate: e.value })}
                                    dateFormat="dd/mm/yy"
                                    locale="tr"
                                    showIcon
                                    appendTo={document.body}
                                    className="w-full"
                                    inputClassName="!py-3.5 !px-5 !rounded-2xl border-slate-200 focus:border-indigo-500 transition-all font-bold text-slate-700"
                                />
                            </div>

                            <div className="space-y-2">
                                <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">TUTAR (TL)</label>
                                <InputNumber
                                    value={expense.amount}
                                    onValueChange={(e) => setExpense({ ...expense, amount: e.value })}
                                    mode="currency"
                                    currency="TRY"
                                    locale="tr-TR"
                                    className="w-full"
                                    inputClassName="!py-3.5 !px-5 !rounded-2xl border-slate-200 focus:border-indigo-500 transition-all font-black text-indigo-600 text-xl"
                                />
                            </div>

                            <div className="flex items-center gap-3 pt-6">
                                <Checkbox
                                    inputId="recurring"
                                    checked={expense.isRecurring}
                                    onChange={(e) => setExpense({ ...expense, isRecurring: e.checked })}
                                    className="w-6 h-6"
                                />
                                <label htmlFor="recurring" className="text-sm font-bold text-slate-700 cursor-pointer">Aylık Düzenli Ödeme Olarak Ekle</label>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* Ödeme Hesabı */}
                            <div className="space-y-2">
                                <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">ÖDEME YAPILACAK HESAP</label>
                                <Dropdown
                                    value={expense.financialAccountId}
                                    options={financialAccounts}
                                    onChange={(e) => setExpense({ ...expense, financialAccountId: e.value })}
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder="Hesap seçin..."
                                    className="w-full rounded-2xl border-slate-200 font-bold"
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">AÇIKLAMA</label>
                            <InputText
                                value={expense.description}
                                onChange={(e) => setExpense({ ...expense, description: e.target.value })}
                                className="w-full !py-4 !px-5 !rounded-2xl border-slate-200 focus:border-indigo-500 transition-all font-medium text-slate-600"
                            />
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-6">
                            <Button
                                type="button"
                                label="VAZGEÇ"
                                icon="pi pi-times"
                                className="flex-1 p-button-text !text-slate-400 font-black !py-4 !rounded-2xl hover:!bg-slate-50 transition-all"
                                onClick={() => navigate("/expenses")}
                            />
                            <Button
                                type="submit"
                                label="DEĞİŞİKLİKLERİ KAYDET"
                                icon="pi pi-check"
                                loading={loading}
                                className="flex-[2] !bg-indigo-600 border-none font-black !py-4 !rounded-2xl shadow-xl shadow-indigo-600/20 hover:!bg-indigo-700 transition-all hover:scale-[1.01] active:scale-[0.99]"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
